// Unified task board constants. Status values match the backend
// (modules/taskBoard/constants.js). There is intentionally no "blocked" status.

export const TASK_STATUSES = [
  { value: "product_backlog", label: "Product Backlog", accent: "bg-faint" },
  { value: "sprint_backlog", label: "Sprint Backlog", accent: "bg-muted" },
  { value: "ready", label: "Ready", accent: "bg-sky-400" },
  { value: "in_progress", label: "In Progress", accent: "bg-accent" },
  { value: "code_review", label: "Code Review", accent: "bg-violet-400" },
  { value: "qa_testing", label: "QA Testing", accent: "bg-warn" },
  { value: "qa_rejected", label: "QA Rejected", accent: "bg-danger" },
  { value: "done", label: "Done", accent: "bg-ok" },
];

export const STATUS_LABELS = Object.fromEntries(TASK_STATUSES.map((s) => [s.value, s.label]));

export const PRIORITIES = [
  { value: "critical", label: "Critical", className: "bg-danger-soft text-danger" },
  { value: "high", label: "High", className: "bg-danger-soft text-danger" },
  { value: "medium", label: "Medium", className: "bg-warn-soft text-warn" },
  { value: "low", label: "Low", className: "bg-raise text-muted" },
];

export const PRIORITY_RANK = { critical: 0, high: 1, medium: 2, low: 3 };

// Conventional-commit style task types.
export const TASK_TYPES = [
  { value: "feat", label: "feat", description: "Feature / user story" },
  { value: "fix", label: "fix", description: "Bug fix" },
  { value: "improvement", label: "improvement", description: "Improve existing behavior" },
];

export const SPRINT_STATUSES = [
  { value: "planned", label: "Planned" },
  { value: "active", label: "Active" },
  { value: "completed", label: "Completed" },
];

export const SQUAD_ROLES = [
  { value: "SQUAD_LEAD", label: "Squad Lead" },
  { value: "MEMBER", label: "Member" },
];

// Product Backlog is the unplanned stage; these fields are required to move a
// task to any later status (enforced by the API too). The squad and assignees
// are optional: without a squad, only high_potit members can be assigned.
export const BACKLOG_STATUS = "product_backlog";
export const PLANNING_FIELDS = ["sprint", "dueDate", "priority"];
export const PLANNING_LABELS = {
  squad: "Squad",
  sprint: "Sprint",
  assignees: "Assignees",
  dueDate: "Due date",
  priority: "Priority",
};

// Filter keys mirrored in the URL query string and sent to GET /tasks.
// Client-side view options (URL params `deadline` / `sort` / `due`, not sent to the API).
export const DEADLINE_FILTERS = [
  { value: "overdue", label: "Overdue" },
  { value: "today", label: "Due today" },
  { value: "week", label: "Next 7 days" },
  { value: "none", label: "No deadline" },
];

export const FILTER_KEYS = ["project", "squad", "sprint", "assignee", "status", "priority", "q"];

// "none" matches tasks without that relation (e.g. unassigned).
export const NONE = "none";
